import { useState, useEffect } from 'react';
import { ncbService } from '../services/ncb';

interface User {
  id: string;
  email: string;
  name?: string;
  createdAt?: string;
}

interface Session {
  user: User | null;
  isLoading: boolean;
}

export const useAuth = () => {
  const [session, setSession] = useState<Session>({
    user: null,
    isLoading: true,
  });

  useEffect(() => {
    checkSession();
  }, []);

  const checkSession = async () => {
    try {
      const data = await ncbService.getSession();
      setSession({
        user: data.user || null,
        isLoading: false,
      });
    } catch (error) {
      console.error("Session check failed:", error);
      setSession({
        user: null,
        isLoading: false
      });
    }
  };

  const signOut = async () => {
    try {
      await ncbService.signOut();
      setSession({
        user: null,
        isLoading: false
      });
      window.location.href = "/";
    } catch (error) {
      console.error("Sign out failed:", error);
    }
  };

  // 🔧 修復:新增 refreshUser 方法,讓登入後能立即更新狀態
  const refreshUser = async () => {
    setSession(prev => ({ ...prev, isLoading: true }));
    await checkSession();
  };

  return {
    user: session.user,
    isLoading: session.isLoading,
    isAuthenticated: !!session.user,
    signOut,
    refreshSession: checkSession,
    refreshUser, // 🆕 暴露給登入頁面使用
  };
};